import React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { ConfirmationModal, useModal } from '@europrocurement/flexy-components';
import { useTransition } from '../../../hooks';
import { useSelectedDossierContext } from '../../../providers';

const RequiredDocumentsStatusAction: React.FunctionComponent = function () {
    const { canApplyTransition, applyTransition } = useTransition();
    const { dossier, refreshDossier } = useSelectedDossierContext();
    const { modalActions } = useModal();
    const { palette } = useTheme();

    const handleUpdateStatusDossierToCheck = async () => {
        if (canApplyTransition(dossier, 'to-check') && dossier.stepId === 3) {
            await applyTransition(dossier, 'to-check');
            refreshDossier();
            modalActions.close();
        }
    };

    const handleUpdateStatusConfirmModal = () => {
        modalActions.call(
            <ConfirmationModal
                messages={{
                    question: 'Confirmation ?',
                    detail: {
                        message: 'Êtes-vous sûr de passer le dossier en A contrôler ?',
                        severity: 'info',
                    },
                }}
                actionOnValidation={handleUpdateStatusDossierToCheck}
                actionOnCancellation={() => {
                    modalActions.close();
                }}
                color={palette.primary}
            />,
        );
    };

    // Action row displayed on on specific condition
    if (!(canApplyTransition(dossier, 'to-check') && dossier.stepId === 3)) {
        return null;
    }

    return (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
            <Button
                onClick={handleUpdateStatusConfirmModal}
                sx={{
                    padding: '8px 20px',
                    fontSize: '16px',
                    background: palette.primary.dark,
                    ':hover': {
                        background: palette.primary.main,
                    },
                    transition: 'all ease-in-out 300ms',
                }}
                variant="contained"
                key="update-status-to-check"
            >
                J&apos;ai ajouté tous mes documents
            </Button>
        </Box>
    );
};

export default RequiredDocumentsStatusAction;
